<template>
    <div class="card">
        <div class="card-block">
            <div class="row">
                <div class="col-sm-12 col-md-9 col-lg-9">
                    <b-button-group>
                        <button id="displayMode__today" class="btn btn-secondary btn-sm" @click.prevent="switchDisplayMode('today')" :class="{ active: viewParams.mode == 'today'}">
                            Сегодня
                        </button>
                        <button id="displayMode__week" class="btn btn-secondary btn-sm" @click.prevent="switchDisplayMode('week')" :class="{ active: viewParams.mode == 'week'}">
                            Неделя
                        </button>
                        <button id="displayMode__twoWeek" class="btn btn-secondary btn-sm" @click.prevent="switchDisplayMode('two-week')" :class="{ active: viewParams.mode == 'two-week'}">
                            Две недели
                        </button>
                        <button id="displayMode__month" class="btn btn-secondary btn-sm" @click.prevent="switchDisplayMode('month')" :class="{ active: viewParams.mode == 'month'}">
                            Месяц
                        </button>
                    </b-button-group>
                    <div class="mb-1 hidden-md-up"></div>
                    <b-button-group>
                        <button id="displayMode__prevInterval" class="btn btn-secondary btn-sm" @click.prevent="prevInterval()">
                            <i class="fa fa-arrow-left"></i>
                        </button>
                        <button id="displayMode__nextInterval" class="btn btn-secondary btn-sm" @click.prevent="nextInterval()">
                            <i class="fa fa-arrow-right"></i>
                        </button>
                        <button id="displayMode__search" class="btn btn-secondary btn-sm" @click.prevent="showSearchModal()" :class="{ active: viewParams.mode == 'search'}">
                            <i class="fa fa-search"></i>
                        </button>
                        <button :disabled="exportLoading" id="displayMode__export" class="btn btn-secondary btn-sm" @click.prevent="exportToExcel()">
                            <i class="fa fa-file-excel-o"></i>
                            Экспорт в Excel
                        </button>
                    </b-button-group>
                    <b-tooltip target="displayMode__today" title="Показать заказы на сегодня" placement="bottom" triggers="hover"></b-tooltip>
                    <b-tooltip target="displayMode__week" title="Показать заказы на текущую неделю" placement="bottom" triggers="hover"></b-tooltip>
                    <b-tooltip target="displayMode__twoWeek" title="Показать заказы на текущую и следующую недели" placement="bottom" triggers="hover"></b-tooltip>
                    <b-tooltip target="displayMode__month" title="Показать заказы на текущий месяц" placement="bottom" triggers="hover"></b-tooltip>
                    <b-tooltip target="displayMode__prevInterval" title="Предыдущий интервал" placement="bottom" triggers="hover"></b-tooltip>
                    <b-tooltip target="displayMode__nextInterval" title="Следующий интервал" placement="bottom" triggers="hover"></b-tooltip>
                    <b-tooltip target="displayMode__search" title="Поиск и выбор заказов по параметрам" placement="bottom" triggers="hover"></b-tooltip>
                    <b-tooltip target="displayMode__export" title="Экспортировать текущие заказы в Excel" placement="bottom" triggers="hover"></b-tooltip>

                </div>
                <div class="col-sm-12 col-md-3 col-lg-3 text-right" v-if="viewParams.dateFrom">
                    Отображаются заказы с {{viewParams.dateFrom}} по {{viewParams.dateTo}}
                </div>
            </div>
        </div>
    </div>
    </div>
</template>
<script>
  import moment from 'moment'
  import { mapState, mapActions } from 'vuex'
  import { exportUrl, getHeader } from './../../config'
  import fileDownload from 'react-file-download'
  import { ADD_TOAST_MESSAGE } from 'vuex-toast'

  export default {
    computed: mapState({
      viewParams: state => state.orderStore.params
    }),
    data () {
      return {
        params: {},
        format: 'DD.MM.YYYY',
        mode: '',
        exportLoading: false
      }
    },
    methods: {
      switchDisplayMode (mode) {
        if (mode === 'search') {
          this.params = JSON.parse(window.localStorage.getItem('displayModeParams'))
          console.log(this.params)
          this.$store.dispatch('getOrders', this.params)
          return
        }
        this.mode = mode
        this.params = {}
        switch (mode) {
          case 'today':
            this.params.dateFrom = moment().format(this.format).toString()
            this.params.dateTo = moment().format(this.format).toString()
            break
          case 'week':
            this.params.dateFrom = moment().startOf('week').format(this.format).toString()
            this.params.dateTo = moment().endOf('week').format(this.format).toString()
            break
          case 'two-week':
            this.params.dateFrom = moment().startOf('week').format(this.format).toString()
            this.params.dateTo = moment().endOf('week').add(1, 'week').format(this.format).toString()
            break
          case 'month':
            this.params.dateFrom = moment().startOf('month').format(this.format).toString()
            this.params.dateTo = moment().endOf('month').format(this.format).toString()
            break
        }
        this.params.mode = mode
        window.localStorage.setItem('displayMode', mode)
        this.$store.dispatch('getOrders', this.params)
      },
      prevInterval () {
        let oldDateFrom = moment(this.params.dateFrom, this.format)
        let oldDateTo = moment(this.params.dateTo, this.format)
        if (this.mode !== 'month') {
          let interval = oldDateTo.diff(oldDateFrom, 'days') + 1
          this.params = {}
          this.params.dateFrom = oldDateFrom.subtract(interval, 'days').format(this.format).toString()
          this.params.dateTo = oldDateTo.subtract(interval, 'days').format(this.format).toString()
        } else {
          this.params = {}
          this.params.dateFrom = oldDateFrom.subtract(1, 'month').format(this.format).toString()
          this.params.dateTo = moment(oldDateTo.subtract(1, 'month').format('YYYY-MM-DD')).endOf('month').format(this.format).toString()
        }
        this.$store.dispatch('getOrders', this.params)
      },
      nextInterval () {
        let oldDateFrom = moment(this.params.dateFrom, this.format)
        let oldDateTo = moment(this.params.dateTo, this.format)
        if (this.mode !== 'month') {
          let interval = oldDateTo.diff(oldDateFrom, 'days') + 1
          this.params = {}
          this.params.dateFrom = oldDateFrom.add(interval, 'days').format(this.format).toString()
          this.params.dateTo = oldDateTo.add(interval, 'days').format(this.format).toString()
        } else {
          this.params = {}
          this.params.dateFrom = oldDateFrom.add(1, 'month').format(this.format).toString()
          this.params.dateTo = moment(oldDateTo.add(1, 'month').format('YYYY-MM-DD')).endOf('month').format(this.format).toString()
        }
        this.$store.dispatch('getOrders', this.params)
      },
      showSearchModal () {
        this.$root.$emit('focusOnHeaderSearchInput')
      },
      exportToExcel () {
        if (this.exportLoading) {
          return
        }
        this.exportLoading = true
        this.$http.post(exportUrl, {
          params: this.viewParams
        }, {
          headers: getHeader(),
          responseType: 'blob'
        }).then((response) => {
          let filename = 'Orders-' + this.viewParams.dateTo + '-' + this.viewParams.dateTo + '.xlsx'
          fileDownload(response.data, filename, 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet')
          this.exportLoading = false
          this.addToast({
            text: 'Отчет успешно сформирован',
            type: 'success',
            dismissAfter: 3000
          })
        }, (error) => {
          console.log(error)
          this.exportLoading = false
          this.addToast({
            text: 'Ошибка формирования отчета. Если ошибка повторяется обратитесь к администратору:' + error,
            type: 'danger',
            dismissAfter: 3000
          })
        })
      },
      ...mapActions({
        addToast: ADD_TOAST_MESSAGE
      })
    },
    created () {
      if (window.localStorage.getItem('displayMode')) {
        let mode = window.localStorage.getItem('displayMode')
        this.switchDisplayMode(mode)
      } else {
        this.switchDisplayMode('today')
      }
    }
  }
</script>



// WEBPACK FOOTER //
// OrderTopPanel.vue?621bd708